export default __webpack_public_path__ + "static/media/image 4.4917234c.png";